export type FEEDBACK_CODES =
  | 'ALL_COMPETENCIES_UNCOVERED'
  | 'SOME_COMPETENCIES_UNCOVERED'
  | 'INSUFFICIENT_COMPETENCY_LEVEL'
  | 'NO_CAPACITY_LEFT'
  | 'ROTATION_VIOLATED'
  | 'NATIONAL_HOLIDAY_ALLOCATION_VIOLATED'
  | 'PERSONAL_HOLIDAY_ALLOCATION_VIOLATED'
  | 'WEEKEND_ALLOCATION_VIOLATED'
  | 'ALLOCATION_OUTSIDE_COMPLETION_WINDOW'
  | 'INVALID_SITE_LOCATION'
  | 'INVALID_INSPECTOR_LOCATION'
  | 'ACTIVITY_PAST_DUE_DATE'
  | 'TRAVEL_LIMIT_EXCEEDED'
  | 'AUTHORIZATION_NOT_VALID_FOR_APPOINTMENT'
  | 'AUTHORIZATION_PARTIALLY_NOT_VALID_FOR_APPOINTMENT';

/** Mirror of backend `AppointmentFeedbackStatus` for API values and comparisons. */
export enum AppointmentFeedbackStatus {
  PENDING = 'pending',
  DONE = 'done',
}

export interface FeedbackCodeDTO {
  id: number;
  code: FEEDBACK_CODES;
  type: 'error' | 'warning';
  description: string;
  appointment?: Date | string;
  /** When this code was last computed for the appointment (from join table). */
  generatedAt?: Date | string | null;
}
